const routes = {}

/** USER **/
routes.consultarUbicacionPorUsuario = {
  route: '/user/login',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Seguridad/Seguridad?wsdl',
  method: 'consultarUbicacionPorUsuario',
  args: ['usuario', 'contrasena']
}

routes.consultarUbicacionPorUsuarioTest = {
  route: '/user/logintest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Seguridad/Seguridad?wsdl',
  method: 'consultarUbicacionPorUsuario',
  args: ['usuario', 'contrasena']
}

routes.consultarClientePorIdContacto = {
  route: '/user/info',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Cliente/Cliente?wsdl',
  method: 'consultarClientePorIdContacto',
  args: ['boidcontacto', 'tipodocumentocliente', 'documentocliente']
}

routes.grabarClienteExporadicoCRM = {
  route: '/user/register',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Cliente/Cliente?wsdl',
  method: 'grabarClienteExporadicoCRM',
  args: ['cliente', 'contacto']
}

routes.consultarClientesCrm = {
  route: '/user/master/consultarclientecrm',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarClientesCrm',
  args: ['documento', 'tipodocumento']
}

routes.recordarContrasena = {
  route: '/user/rememberpassword',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Seguridad/Seguridad?wsdl',
  method: 'recordarContrasena',
  args: ['email']
}

/** MASTER **/
routes.consultarCiudadesOrigenDestino = {
  route: '/master/checkcitiesod',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarCiudadesOrigenDestino',
  args: ['opcion']
}

routes.consultarCiudadesOrigenDestinoTest = {
  route: '/master/checkcitiesodtest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarCiudadesOrigenDestino',
  args: ['opcion']
}

routes.consultarEstadoEnvio = {
  route: '/master/checkstatus',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarEstadoEnvio',
  args: []
}

routes.consultarPaises = {
  route: '/master/consultarpaises',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarEstadoEnvio',
  args: []
}

routes.consultarDepartamentos = {
  route: '/master/consultardepartamentos',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarDepartamentos',
  args: ['idpais']
}

routes.consultarTipoEmpaqueLegado = {
  route: '/master/consultartiposempaqueslegado',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarTipoEmpaqueLegado',
  args: ['numerodocumento', 'digitoverificacion', 'cuenta']
}

/** RASTREO */
routes.consultarTrazabilidadRemesa = {
  route: '/tracking/wid',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Remesa/consultasRemesa?wsdl',
  method: 'consultarTrazabilidadRemesa',
  args: [
    'fechainicial', 'fechafinal', 'identificacionremitente', 'idciudadorigen', 'idciudaddestino',
    'estadoremesa', 'nombredestinatario', 'remesas', 'codigobolsa', 'numerodocumentoreferencia',
    'tipodocumentoreferencia', 'cuentas', 'identificacionpagador', 'esboomerang'
  ]
}

routes.consultarTrazabilidadRemesaTest = {
  route: '/tracking/widtest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Remesa/consultasRemesa?wsdl',
  method: 'consultarTrazabilidadRemesa',
  args: [
    'fechainicial', 'fechafinal', 'identificacionremitente', 'idciudadorigen', 'idciudaddestino',
    'estadoremesa', 'nombredestinatario', 'remesas', 'codigobolsa', 'numerodocumentoreferencia',
    'tipodocumentoreferencia', 'cuentas', 'identificacionpagador', 'esboomerang'
  ]
}

routes.consultarTrazabilidadRemesaArchivo = {
  route: '/tracking/widfile',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Remesa/consultasRemesa?wsdl',
  method: 'consultarTrazabilidadRemesaArchivo',
  args: [
    'fechainicial', 'fechafinal', 'identificacionremitente', 'idciudadorigen', 'idciudaddestino',
    'estadoremesa', 'nombredestinatario', 'remesas', 'codigobolsa', 'numerodocumentoreferencia',
    'cuentas', 'usuario', 'opcion'
  ]
}

routes.consultarTrazabilidadRemesaArchivoChannel = {
  route: '/tracking/widfilechannel',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/remesas/consultarinformacionremesacliente',
  type: 'rest',
  args: ['identificacionremitente', 'fechainicial', 'fechafinal', 'remesas'],
  headers: ['accesstoken']
}

routes.consultarTipoEmpaqueLegado = {
  route: '/user/master/tipoempaque',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarTipoEmpaqueLegado',
  args: ['cuenta']
}

routes.consultarInformacionRemesasEstados = {
  route: '/tracking/estados',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Trazabilidad/Trazabilidad?wsdl',
  method: 'consultarInformacionRemesasEstados',
  args: ['remesas', 'token']
}

routes.consultarInformacionRemesasEstadosTest = {
  route: '/tracking/estadostest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Trazabilidad/Trazabilidad?wsdl',
  method: 'consultarInformacionRemesasEstados',
  args: ['infoadicional', 'remesas', 'token']
}

/** COTIZAR ENVIO **/
routes.consultarliquidacionTest = {
  route: '/cotizarenvio/liquidaciontest',
  wsdl: 'http://clientes.tcc.com.co/preservicios/liquidacionacuerdos.asmx?wsdl',
  method: 'consultarliquidacion2',
  args: ['Clave', 'Liquidacion']
}

routes.consultarliquidacion = {
  route: '/cotizarenvio/liquidacion',
  wsdl: 'http://clientes.tcc.com.co/servicios/LiquidacionAcuerdos.asmx?wsdl',
  method: 'consultarliquidacion2',
  args: ['Clave', 'Liquidacion']
}

routes.consultarliquidacionExtraTest = {
  route: '/cotizarenvio/liquidacionextratest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/tarifas/v6/consultarliquidacion',
  headers: ['accesstoken'],
  args: [
    'tipoenvio', 'idciudadorigen', 'idciudaddestino', 'valormercancia', 'boomerang', 'identificacion',
    'tipoidentificacion', 'cuenta', 'fecharemesa', 'idunidadnegocio', 'recaudo', 'unidades', 'tipoboomerang'
  ]
}

routes.consultarliquidacionExtra = {
  route: '/cotizarenvio/liquidacionextra',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/tarifas/v6/consultarliquidacion',
  headers: ['accesstoken'],
  args: [
    'tipoenvio', 'idciudadorigen', 'idciudaddestino', 'valormercancia', 'boomerang', 'identificacion',
    'tipoidentificacion', 'cuenta', 'fecharemesa', 'idunidadnegocio', 'recaudo', 'unidades', 'tipoboomerang'
  ]
}

/** COTIZAR ENVIO BOX NUEVAS RUTAS **/
routes.consultarCiudades = {
  route: '/casillero/maestro/ciudad',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/Maestro/Ciudad',
  headers: ['accesstoken'],
  args: ['pais']
}

routes.posicionArancel = {
  route: '/casillero/maestro/posicionarancel',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/Maestro/PosicionArancel',
  headers: ['accesstoken'],
  args: []
}

routes.unidadesLongitud = {
  route: '/casillero/maestro/unidadlongitud',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/Maestro/UnidadLongitud',
  headers: ['accesstoken'],
  args: []
}

routes.unidadesPeso = {
  route: '/casillero/maestro/unidadpeso',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/Maestro/UnidadPeso',
  headers: ['accesstoken'],
  args: []
}

routes.calcularDespacho = {
  route: '/casillero/calculardespacho',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/CalcularDespacho',
  headers: ['accesstoken'],
  args: ['ciudaddestino', 'idmedidapeso', 'peso', 'idmedidavolumen', 'alto', 'largo', 'ancho', 'valordeclarado', 'idtipopago', 'posicionarancelaria', 'cuenta']
}

/** SOLICITAR RECOGIDA **/

routes.grabarSolicitudRecogidaPortalLegado = {
  route: '/solicitarrecogida',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/SolicitudRecogidaV1/SolicitudRecogidaV1?wsdl',
  method: 'grabarSolicitudRecogidaPortalLegado',
  args: [
    'solicitante', 'ciudad', 'tipodocumento', 'numerodocumento', 'nombre', 'direccion', 'email', 'telefono',
    'notificar', 'remitente', 'ciudad', 'tipodocumento', 'numerodocumento', 'nombre', 'direccion', 'email',
    'telefono', 'contacto', 'formapago', 'cuenta', 'oficina', 'totalnumerounidades', 'totalkilosvolumen', 'totalkilosreal',
    'totalvalormercancia', 'observaciones', 'fecharecogida', 'fechahorainiciorecogida', 'fechahorafinrecogida', 'notificaciones',
    'rangohorario', 'unidadnegocio', 'mercancialista', 'unidades', 'generaremesa', 'destinatario'],
  headers: {
    'acceso': {
      'usuario': 'PORTAL',
      'contrasena': 'PORTAL@123456'
    }
  }
}

routes.grabarSolicitudRecogidaPortalLegadoOld = {
  route: '/solicitarrecogidaold',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/SolicitudRecogida/SolicitudRecogida?wsdl',
  method: 'grabarSolicitudRecogidaPortalLegado',
  args: ['solicitante', 'ciudad', 'tipodocumento', 'numerodocumento', 'nombre', 'direccion', 'email', 'telefono', 'notificar', 'remitente', 'ciudad', 'tipodocumento', 'numerodocumento', 'nombre', 'direccion', 'email', 'telefono', 'contacto', 'formapago', 'cuenta', 'oficina', 'totalnumerounidades', 'totalkilosvolumen', 'totalkilosreal', 'totalvalormercancia', 'observaciones', 'fecharecogida', 'fechahorainiciorecogida', 'fechahorafinrecogida', 'notificaciones', 'unidades'],
  headers: {
    'acceso': {
      'usuario': 'PORTAL',
      'contrasena': 'PORTAL@123456'
    }
  }
}

routes.grabarSolicitudRecogidaPortalLegadoTest = {
  route: '/solicitarrecogidatest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/SolicitudRecogidaV1/SolicitudRecogidaV1?wsdl',
  method: 'grabarSolicitudRecogidaPortalLegado',
  args: [
    'solicitante', 'ciudad', 'tipodocumento', 'numerodocumento', 'nombre', 'direccion', 'email', 'telefono',
    'notificar', 'remitente', 'ciudad', 'tipodocumento', 'numerodocumento', 'nombre', 'direccion', 'email',
    'telefono', 'contacto', 'formapago', 'cuenta', 'oficina', 'totalnumerounidades', 'totalkilosvolumen', 'totalkilosreal',
    'totalvalormercancia', 'observaciones', 'fecharecogida', 'fechahorainiciorecogida', 'fechahorafinrecogida', 'notificaciones',
    'rangohorario', 'unidadnegocio', 'mercancialista', 'unidades', 'generaremesa', 'destinatario'],
  headers: {
    'acceso': {
      'usuario': 'PORTAL',
      'contrasena': 'PORTAL@123456'
    }
  }
}

routes.validarSolicitudRecogida = {
  route: '/validarsolicitarrecogida',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/SolicitudRecogidaV1/SolicitudRecogidaV1?wsdl',
  method: 'validarSolicitudRecogida',
  args: ['fecharecogida', 'ciudadrecogida', 'unidadnegocio'],
  headers: {
    'acceso': {
      'usuario': 'PORTAL',
      'contrasena': 'PORTAL@123456'
    }
  }
}

routes.validarSolicitudRecogidaTest = {
  route: '/validarsolicitarrecogidatest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/SolicitudRecogidaV1/SolicitudRecogidaV1?wsdl',
  method: 'validarSolicitudRecogida',
  args: ['fecharecogida', 'ciudadrecogida', 'unidadnegocio'],
  headers: {
    'acceso': {
      'usuario': 'PORTAL',
      'contrasena': 'PORTAL@123456'
    }
  }
}

routes.consultarSolicitudRecogida = {
  route: '/consultasolicitudrecogida',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/SolicitudRecogida/SolicitudRecogida?wsdl',
  method: 'consultarSolicitudRecogida',
  args: ['numerodocsolicitante', 'idrecogida', 'fecharecogidainicial', 'fecharecogidafinal'],
  headers: {
    'acceso': {
      'usuario': 'PORTAL',
      'contrasena': 'PORTAL@123456'
    }
  }
}

routes.consultarSolicitudRecogidaTest = {
  route: '/consultasolicitudrecogidatest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/SolicitudRecogidaV1/SolicitudRecogidaV1?wsdl',
  method: 'consultarSolicitudRecogida',
  args: ['numerodocsolicitante', 'idrecogida', 'fecharecogidainicial', 'fecharecogidafinal'],
  headers: {
    'acceso': {
      'usuario': 'PORTAL',
      'contrasena': 'PORTAL@123456'
    }
  }
}

routes.anularSolicitudRecogida = {
  route: '/anularsolicitudrecogida',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/SolicitudRecogida/SolicitudRecogida?wsdl',
  method: 'anularSolicitudRecogida',
  args: ['idrecogida', 'oficina', 'motivoanulacion'],
  headers: {
    'acceso': {
      'usuario': 'PORTAL',
      'contrasena': 'PORTAL@123456'
    }
  }
}

routes.anularSolicitudRecogidaTest = {
  route: '/anularsolicitudrecogidatest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/SolicitudRecogida/SolicitudRecogida?wsdl',
  method: 'anularSolicitudRecogida',
  args: ['idrecogida', 'oficina', 'motivoanulacion'],
  headers: {
    'acceso': {
      'usuario': 'PORTAL',
      'contrasena': 'PORTAL@123456'
    }
  }
}

/** PREENVIO **/
// routes.solicitarPreenvio = {
//     route: '/solicitarpreenvio',
//     wsdl: 'http://clientes.tcc.com.co:4080/api/clientes/remesasws?wsdl',
//     method: 'grabardespacho7',
//     args: ['despacho']
// }

// routes.solicitarPreenvioTest = {
//     route: '/solicitarpreenviotest',
//     wsdl: 'http://preclientes.tcc.com.co:1080/api/clientes/remesasws?wsdl',
//     method: 'grabardespacho7',
//     args: ['despacho']
// }
routes.solicitarPreenvio2 = {//lo usa tcc publico y falkon transaccional
  route: '/solicitarpreenvio2',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/remesas/grabardespacho7',
  args: ['numerorelacion', 'fechahorarelacion', 'solicitudrecogida', 'unidadnegocio', 'numeroremesa',
    'fechadespacho', 'cuentaremitente', 'tipoidentificacionremitente', 'identificacionremitente', 'sederemitente',
    'primernombreremitente', 'segundonombreremitente', 'primerapellidoremitente', 'segundoapellidoremitente', 'razonsocialremitente',
    'naturalezaremitente', 'direccionremitente', 'contactoremitente', 'emailremitente', 'telefonoremitente', 'ciudadorigen', 'tipoidentificaciondestinatario',
    'identificaciondestinatario', 'sededestinatario', 'primernombredestinatario', 'segundonombredestinatario', 'primerapellidodestinatario',
    'segundoapellidodestinatario', 'razonsocialdestinatario', 'naturalezadestinatario', 'direcciondestinatario', 'contactodestinatario',
    'emaildestinatario', 'telefonodestinatario', 'ciudaddestinatario', 'barriodestinatario', 'totalpeso', 'totalpesovolumen',
    'formapago', 'observaciones', 'llevabodega', 'recogebodega', 'centrocostos', 'totalvalorproducto', 'generardocumentos', 'generarbinarios',
    'unidades', 'tiposervicio', 'documentosreferencia', 'totalvalormercancia']
}
routes.solicitarPreenvioTest2 = {//lo usa tcc publico y falkon transaccional
  route: '/solicitarpreenviotest2',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/remesas/grabardespacho7',
  args: ['numerorelacion', 'fechahorarelacion', 'solicitudrecogida', 'unidadnegocio', 'numeroremesa',
    'fechadespacho', 'cuentaremitente', 'tipoidentificacionremitente', 'identificacionremitente', 'sederemitente',
    'primernombreremitente', 'segundonombreremitente', 'primerapellidoremitente', 'segundoapellidoremitente', 'razonsocialremitente',
    'naturalezaremitente', 'direccionremitente', 'contactoremitente', 'emailremitente', 'telefonoremitente', 'ciudadorigen', 'tipoidentificaciondestinatario',
    'identificaciondestinatario', 'sededestinatario', 'primernombredestinatario', 'segundonombredestinatario', 'primerapellidodestinatario',
    'segundoapellidodestinatario', 'razonsocialdestinatario', 'naturalezadestinatario', 'direcciondestinatario', 'contactodestinatario',
    'emaildestinatario', 'telefonodestinatario', 'ciudaddestinatario', 'barriodestinatario', 'totalpeso', 'totalpesovolumen',
    'formapago', 'observaciones', 'llevabodega', 'recogebodega', 'centrocostos', 'totalvalorproducto', 'generardocumentos', 'generarbinarios',
    'unidades', 'tiposervicio', 'documentosreferencia', 'totalvalormercancia']
}

/** RUTA INFORMATIVA **/
routes.consutarRutaInformativa = {
  route: '/rutainformativa',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Remesa/consultasRemesa?wsdl',
  method: 'consutarRutaInformativa',
  args: ['cuentas', 'fechainicial', 'fechafinal', 'usuario']
}

/** FACTURAS **/
routes.consultarListadoFacturas = {
  route: '/facturas/listado',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Facturacion/Facturacion?wsdl',
  method: 'consultarListadoFacturas',
  args: ['fechainicial', 'fechafinal', 'cuentas', 'identificacion', 'tipoidentificacion', 'unidadnegocio', 'remesa']
}

routes.consultarListadoFacturasTest = {
  route: '/facturas/listadotest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Facturacion/Facturacion?wsdl',
  method: 'consultarListadoFacturas',
  args: ['fechainicial', 'fechafinal', 'cuentas', 'identificacion', 'tipoidentificacion', 'unidadnegocio', 'remesa']
}

routes.consultarDetalleAnexoFacturas = {
  route: '/facturas/anexo',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Facturacion/Facturacion?wsdl',
  method: 'consultarDetalleAnexoFacturas',
  args: ['numerofactura']
}

routes.consultarDetalleAnexoFacturasTest = {
  route: '/facturas/anexotest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Facturacion/Facturacion?wsdl',
  method: 'consultarDetalleAnexoFacturas',
  args: ['numerofactura']
}

/** CARGA MASIVA **/
routes.consultarDespachoTransito = {
  route: '/cargamasiva/transito',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Sitrac/Sitrac?wsdl',
  method: 'consultarDespachoTransito',
  args: ['nit', 'fechainicial', 'fechafinal', 'documentocliente', 'placa', 'lineanegocio', 'remesa']
}

routes.consultarDespachoFinalizado = {
  route: '/cargamasiva/finalizado',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Sitrac/Sitrac?wsdl',
  method: 'consultarDespachoFinalizado',
  args: ['nit', 'fechainicial', 'fechafinal', 'documentocliente', 'placa', 'lineanegocio', 'remesa']
}

routes.consultarDespachoFinalizadoDetalle = {
  route: '/cargamasiva/detalle',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Sitrac/Sitrac?wsdl',
  method: 'consultarDespachoFinalizadoDetalle',
  args: ['viaje']
}

routes.cargaMasivaFacturacionTest = {
  route: '/cargamasiva/facturaciontest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Facturacion/Facturacion?wsdl',
  method: 'consultarFacturaClientes',
  args: ['fechainicial', 'fechafinal', 'cuentas', 'identificacion', 'tipoidentificacion', 'unidadnegocio', 'factura', 'remesa']
}

routes.cargaMasivaFacturacion = {
  route: '/cargamasiva/facturacion',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Facturacion/Facturacion?wsdl',
  method: 'consultarFacturaClientes',
  args: ['fechainicial', 'fechafinal', 'cuentas', 'identificacion', 'tipoidentificacion', 'unidadnegocio', 'factura', 'remesa']
}

/** REMESAS INTERNACIONALES **/
routes.GET_CASILLERO_CUENTAS = {
  route: '/casillero/cuentas',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/Cuenta',
  headers: ['accesstoken'],
  args: ['correo']
}

routes.GET_CASILLERO_REMESAS = {
  route: '/casillero/remesa',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/Remesa',
  headers: ['accesstoken'],
  args: ['idcuenta', 'fechainicial', 'fechafinal', 'codigocasillero']
}

routes.GET_CASILLERO_REMESAS_DETALLE = {
  route: '/casillero/remesadetalle',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/RemesaDetalle',
  headers: ['accesstoken'],
  args: ['guia']
}

routes.GET_INGRESO_CONTENIDO = {
  route: '/casillero/ingresocontenido',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/IngresoContenido',
  headers: ['accesstoken'],
  args: ['idservicio', 'unidades']
}

/** Certificado de Entrega - Público **/
routes.consutarCertificadoEntrega = {
  route: '/consultarcertificadoentrega',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Remesa/consultasRemesa?wsdl',
  method: 'consutarCertificadoEntrega',
  args: [
    'remesas', 'correoelectronico'
  ]
}

/** Tiempos de entreg - Público **/
routes.consultarDiasEntrega = {
  route: '/consultardiasentrega',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarDiasEntrega',
  args: [
    'ciudadorigen', 'ciudaddestino', 'fechadespacho'
  ]
}

/** Tiempos de entreg - Público **/
routes.consultarDiasEntregaTest = {
  route: '/consultardiasentregatest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarDiasEntrega',
  args: [
    'ciudadorigen', 'ciudaddestino', 'fechadespacho'
  ]
}

/** PQR **/
routes.ListaTiposSolicitudes = {
  route: '/pqr/tipossolicitudes',
  wsdl: 'http://clientes.tcc.com.co/servicios/PQRsMensajeria.asmx?wsdl',
  method: 'ListaTiposSolicitudes',
  args: [
    'clave'
  ]
}

routes.ListaTiposPQR = {
  route: '/pqr/tipospqr',
  wsdl: 'http://clientes.tcc.com.co/servicios/PQRsMensajeria.asmx?wsdl',
  method: 'ListaTiposPQR',
  args: [
    'clave', 'IDTipoSolicitud'
  ]
}

routes.ListaDepartamentos = {
  route: '/pqr/departamentos',
  wsdl: 'http://clientes.tcc.com.co/servicios/PQRsMensajeria.asmx?wsdl',
  method: 'ListaDepartamentos',
  args: [
    'clave'
  ]
}

routes.ListaCiudades = {
  route: '/pqr/ciudades',
  wsdl: 'http://clientes.tcc.com.co/servicios/PQRsMensajeria.asmx?wsdl',
  method: 'ListaCiudades',
  args: [
    'clave', 'IDDepartamento'
  ]
}

routes.GrabarPQR = {
  route: '/pqr/grabarpqr',
  wsdl: 'http://clientes.tcc.com.co/servicios/PQRsMensajeria.asmx?wsdl',
  method: 'GrabarPQR',
  args: [
    'clave', 'PQR', 'archivoPDF'
  ]
}

routes.GrabarPQRTest = {
  route: '/pqr/grabarpqrtest',
  wsdl: 'http://clientes.tcc.com.co/preservicios/PQRsMensajeria.asmx?wsdl', // WARNING esta url es preservicios
  method: 'GrabarPQR',
  args: [
    'clave', 'PQR', 'archivoPDF'
  ]
}

routes.ConsultarPQR = {
  route: '/pqr/consultapqr',
  wsdl: 'http://clientes.tcc.com.co/servicios/PQRsMensajeria.asmx?wsdl',
  method: 'ConsultarPQR',
  args: [
    'clave', 'TipoIdentificacion', 'Identificacion', 'CodigoCUN'
  ]
}

routes.consultaCUNTest = {
  route: '/pqr/consultacuntest',
  wsdl: 'http://clientes.tcc.com.co/wsConsultaCUN/WSConsultaOperador.asmx?wsdl',
  method: 'consultaCUN',
  args: [
    'identificadorOperador', 'anoRadicacionCun', 'ConsecutivoRadCun',
    'tipoIdentificacion', 'numeroIdentificacion'
  ]
}

routes.consultaCUN = {
  route: '/pqr/consultacunpqr',
  wsdl: 'http://wscun.sic.gov.co:8280/services/WSConsultaSIC?wsdl',
  method: 'consultaCUN',
  args: [
    'identificadorOperador', 'anoRadicacionCun', 'ConsecutivoRadCun', 'numeroRadicacion',
    'anoRadicacion', 'nombreOperador', 'tipoIdentificacion', 'numeroIdentificacion'
  ]
}

routes.consultarListasPqr = {
  route: '/pqr/consultarlistaspqr',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarListasPqr',
  args: [
    'unidadnegocio', 'pqr', 'tipopqr', 'motivopqr'
  ]
}

routes.consultarListasPqrTest = {
  route: '/pqr/consultarlistaspqrtest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarListasPqr',
  args: [
    'unidadnegocio', 'pqr', 'tipopqr', 'motivopqr'
  ]
}

/** BOX **/
routes.crearCasillero = {
  route: '/casillero/crear',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/Crear',
  headers: ['accesstoken'],
  args: ['nombre', 'idtipoidentificacion', 'identificacion', 'direccion', 'zip', 'telefono1', 'telefono2', 'email', 'idciudad', 'idpais', 'contrasena', 'comentarios']
}

routes.actualizarCasillero = {
  route: '/casillero/actualizar',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/Actualizar',
  headers: ['accesstoken'],
  args: ['codigocasillero', 'nombre', 'idtipoidentificacion', 'identificacion', 'direccion', 'zip', 'telefono1', 'telefono2', 'email', 'idciudad', 'idpais', 'contrasena', 'comentarios']
}

routes.consultaCasillero = {
  route: '/casillero/consulta',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/ConsultarPorCodigo',
  headers: ['accesstoken'],
  args: ['codigocasillero']
}

routes.validarCasillero = {
  route: '/box/validarcasillero',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Seguridad/Seguridad?wsdl',
  method: 'validarCasillero',
  args: ['usuario']
}

routes.declararCasillero = {
  route: '/box/declararcasillero',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Casillero/IngresoContenido',
  headers: ['accesstoken'],
  args: ['idservicio', 'unidades']
}

/** FACTURACION **/

routes.consultarPdf = {
  route: '/facturacion/consultarpdf',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Facturacion/ConsultarPDF',
  headers: ['accesstoken'],
  args: ['numerodocumento', 'fechadocumento', 'unidadnegocio', 'tipodocumento', 'formapago', 'identificacion', 'numeroremesa']
}

routes.consultarPdfTest = {
  route: '/facturacion/consultarpdftest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co:8484/Api/Facturacion/ConsultarPDF',
  headers: ['accesstoken'],
  args: ['numerodocumento', 'fechadocumento', 'unidadnegocio', 'tipodocumento', 'formapago', 'identificacion', 'numeroremesa']
}

routes.consultarDatosFacturacion = {
  route: '/facturacion/consultardatos',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/api/clientes/facturasws?wsdl',
  method: 'enviarnotificacionfe',
  options: {
    forceSoap12Headers: true,
    endpoint: 'http://prod.servicios.tcc.com.co:8011/api/clientes/facturasws?wsdl'
  },
  args: ['clave', 'identificacion', 'remesa', 'correoelectronico']
}

routes.consultarDatosFacturacionTest = {
  route: '/facturacion/consultardatostest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/api/clientes/facturasws?wsdl',
  method: 'enviarnotificacionfe',
  options: { forceSoap12Headers: true },
  args: ['clave', 'identificacion', 'remesa', 'correoelectronico']
}

routes.consultarRemesaAuditada = {
  route: '/facturacion/consultarremesaauditada',
  type: 'rest',
  endpoint: 'http://prod.servicios.tcc.com.co:8011/api/clientes/remesas/consultarremesaauditada',
  args: ['clave', 'fechainicial', 'fechafinal', 'idcliente', 'remesas']
}

routes.consultarRemesaAuditadaTest = {
  route: '/facturacion/consultarremesaauditadatest',
  type: 'rest',
  endpoint: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/api/clientes/remesas/consultarremesaauditada',
  args: ['clave', 'fechainicial', 'fechafinal', 'idcliente', 'remesas']
}

routes.consultarImagenAuditoria = {
  route: '/facturacion/consultarimagenauditoria',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://somos.tcc.com.co/api/imagenes/consultarimagenauditoria',
  args: ['codigobarras']
}

routes.consultarImagenAuditoriaTest = {
  route: '/facturacion/consultarimagenauditoriatest',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://testsomos.tcc.com.co:8484/api/imagenes/consultarimagenauditoria',
  args: ['codigobarras']
}

/** ENTREGAS ESPECIALES **/

routes.servicioDeEntregasEspeciales = {
  route: '/entregasespeciales/consultarnovedades',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Sees/consultarnovedades',
  headers: ['accesstoken'],
  args: ['id', 'novedades']
}

routes.servicioDeEntregasEspecialesTest = {
  route: '/entregasespeciales/consultarnovedadestest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co:8484/Api/Sees/consultarnovedades',
  headers: ['accesstoken'],
  args: ['id', 'novedades']
}

routes.serviciosEspecialesAprobacionRechazo = {
  route: '/entregasespeciales/aprobacioncita',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/Api/Sees/aprobacioncita',
  headers: ['accesstoken'],
  args: ['idlocalizacion', 'idnovedad', 'fechacita', 'horacita', 'seguimiento', 'codigoautorizacion', 'usuario', 'ipusuario']
}

routes.serviciosEspecialesAprobacionRechazoTest = {
  route: '/entregasespeciales/aprobacioncitatest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co:8484/Api/sees/aprobacioncita',
  headers: ['accesstoken'],
  args: ['idlocalizacion', 'idnovedad', 'fechacita', 'horacita', 'seguimiento', 'codigoautorizacion', 'usuario', 'ipusuario']
}

/** ENTREGAS ESPECIALES **/

routes.aulaVirtualRegistro = {
  route: '/aula/registro',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://somos.tcc.com.co/api/aula/crearusuario',
  args: ['email', 'password', 'firstname', 'lastname']
}

routes.aulaVirtualRegistroTest = {
  route: '/aula/registrotest',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://testsomos.tcc.com.co:8484/api/aula/crearusuario',
  args: ['email', 'password', 'firstname', 'lastname']
}

routes.registroGestionNovedades = {
  route: '/novedades/registro',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Novedad/Novedad?wsdl',
  method: 'grabarMedioContacto',
  args: ['numeroidentificacion', 'email']
}

routes.registroGestionNovedadesTest = {
  route: '/novedades/registrotest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Novedad/Novedad?wsdl',
  method: 'grabarMedioContacto',
  args: ['numeroidentificacion', 'email']
}

/* INTERNACIONAL */

routes.consultarEncabezadoTest = {
  route: '/internacional/consultarencabezadotest',
  type: 'rest',
  endpoint: 'http://preclientes.tcc.com.co:1080/api/cargainternacional/consultarencabezado',
  args: ['token', 'nit', 'nits']
}

routes.consultarEncabezado = {
  route: '/internacional/consultarencabezado',
  type: 'rest',
  endpoint: 'http://prod.servicios.tcc.com.co:8011/api/cargainternacional/consultarencabezado',
  args: ['token', 'nit', 'nits']
}

routes.consultarEstadosOperacionTest = {
  route: '/internacional/consultarestadosoperaciontest',
  type: 'rest',
  endpoint: 'http://preclientes.tcc.com.co:1080/api/cargainternacional/consultarestadosoperacion',
  args: ['token', 'nit', 'ordencompra']
}

routes.consultarEstadosOperacion = {
  route: '/internacional/consultarestadosoperacion',
  type: 'rest',
  endpoint: 'http://prod.servicios.tcc.com.co:8011/api/cargainternacional/consultarestadosoperacion',
  args: ['token', 'nit', 'ordencompra']
}

routes.consultarCostosTest = {
  route: '/internacional/consultarcostostest',
  type: 'rest',
  endpoint: 'http://preclientes.tcc.com.co:1080/api/cargainternacional/consultarcostos',
  args: ['token', 'nit', 'idoperacioncarga', 'idoperacionaduana']
}

/* NOVEDADES */

routes.consultarNovedadesV2Test = {
  route: '/novedades/v2/consultarnovedadestest',
  type: 'rest',
  headers: ['accesstoken', 'accesstokenenc'],
  endpoint: 'https://testsomos.tcc.com.co/api/novedades/v2/consultarnovedades',
  args: ['identificacion', 'fechainicial', 'fechafinal', 'remesas', 'cuentas', 'estadosnovedad', 'unidadesnegocio', 'tiposgestion', 'fuente']
}

routes.consultarNovedadesV2 = {
  route: '/novedades/v2/consultarnovedades',
  type: 'rest',
  headers: ['accesstoken', 'accesstokenenc'],
  endpoint: 'https://somos.tcc.com.co/api/novedades/v2/consultarnovedades',
  args: ['identificacion', 'fechainicial', 'fechafinal', 'remesas', 'cuentas', 'estadosnovedad', 'unidadesnegocio', 'tiposgestion', 'fuente']
}

routes.consultarNovedades = {
  route: '/novedades/consultarnovedades',
  type: 'rest',
  headers: ['accesstoken', 'accesstokenenc'],
  endpoint: 'https://somos.tcc.com.co/api/novedades/v1/consultarnovedades',
  args: ['identificacion', 'fechainicial', 'fechafinal', 'remesas', 'cuentas', 'estadosnovedad', 'unidadesnegocio', 'tiposgestion']
}

routes.consultarNovedadesTest = {
  route: '/novedades/consultarnovedadestest',
  type: 'rest',
  headers: ['accesstoken', 'accesstokenenc'],
  endpoint: 'https://testsomos.tcc.com.co/api/novedades/v1/consultarnovedades',
  args: ['identificacion', 'fechainicial', 'fechafinal', 'remesas', 'cuentas', 'estadosnovedad', 'unidadesnegocio', 'tiposgestion']
}

routes.grabarSeguimiento = {
  route: '/novedades/grabarseguimiento',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://somos.tcc.com.co/api/novedades/v1/grabarseguimiento',
  args: ["idnovedad", "identificacion", "fechareofrecimiento", "seguimiento", "usuario", "ipusuario"]
}

routes.grabarSeguimientoTest = {
  route: '/novedades/grabarseguimientotest',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://testsomos.tcc.com.co/api/novedades/v1/grabarseguimiento',
  args: ["idnovedad", "identificacion", "fechareofrecimiento", "seguimiento", "usuario", "ipusuario"]
}

routes.grabarRemesaSolucion = {
  route: '/novedades/grabarremesasolucion',
  type: 'rest',
  headers: ['accesstoken', 'accesstokenenc'],
  endpoint: 'https://somos.tcc.com.co/api/novedades/v1/grabarremesasolucion',
  args: ["idnovedad", "identificacion", "daneorigen", "danedestino", "idremite", "nombreremite", "direccionremite", "telefonoremite",
    "iddestino", "nombredestino", "direcciondestino", "telefonodestino", "formapago", "cuenta", "idautorizador", "numerounidades",
    "pesoreal", "pesovolumen", "valormercancia", "tiposolucion", "seguimiento", "usuario", "ipusuario", "fuente"]
}

routes.grabarRemesaSolucionTest = {
  route: '/novedades/grabarremesasoluciontest',
  type: 'rest',
  headers: ['accesstoken', 'accesstokenenc'],
  endpoint: 'https://testsomos.tcc.com.co/api/novedades/v1/grabarremesasolucion',
  args: ["idnovedad", "identificacion", "daneorigen", "danedestino", "idremite", "nombreremite", "direccionremite", "telefonoremite",
    "iddestino", "nombredestino", "direcciondestino", "telefonodestino", "formapago", "cuenta", "idautorizador", "numerounidades",
    "pesoreal", "pesovolumen", "valormercancia", "tiposolucion", "seguimiento", "usuario", "ipusuario", "fuente"]
}

routes.complianceIdentificationTest = {
  route: '/compliancetest',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://testsomos.tcc.com.co/api/compliance/consultarindentificacionbasica',
  args: ['identificacion', 'tipoIdentificacion', 'validarListas']
}

routes.complianceIdentification = {
  route: '/compliance',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://somos.tcc.com.co/api/compliance/consultarindentificacionbasica',
  args: ['identificacion', 'tipoIdentificacion', 'validarListas']
}

//new routes compliance
routes.serviceComplianceIdentificationTest = {
  route: '/service-compliancetest',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://testsomos.tcc.com.co/api/compliance/consultarindentificacion',
  args: ['nombre', 'identificacion', 'tipoIdentificacion', 'validarListas']
}

routes.serviceComplianceIdentification = {
  route: '/service-compliance',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://somos.tcc.com.co/api/compliance/consultarindentificacion',
  args: ['nombre', 'identificacion', 'tipoIdentificacion', 'validarListas']
}

/* RÓTULOS Y DESPACHOS */
routes.rotulosDespachoTest = {
  route: '/rotulosdespachotest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/remesas/impresionrotulos',
  headers: ['accesstoken'],
  args: ['identificacion', 'remesas', 'idrotulo']
}

routes.rotulosDespacho = {
  route: '/rotulosdespacho',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/remesas/impresionrotulos',
  headers: ['accesstoken'],
  args: ['identificacion', 'remesas', 'idrotulo']
}

routes.grabarDespachoMasivoTest = {
  route: '/clientes/remesas/grabardespacho8test',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/remesas/grabardespacho8',
  headers: ['accesstoken'],
  args: ['numerodespacho', 'fechadespacho', 'solicitudrecogida', 'unidadnegocio',
    'cuentaremitente', 'sederemitente', 'primernombreremitente',
    'segundonombreremitente', 'primerapellidoremitente', 'segundoapellidoremitente',
    'razonsocialremitente', 'contactoremitente', 'tipoidentificacionremitente',
    'identificacionremitente', 'direccionremitente', 'ciudadorigen', 'telefonoremitente',
    'emailremitente', 'destinatarios']
}

routes.grabarDespachoMasivo = {
  route: '/clientes/remesas/grabardespacho8',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/remesas/grabardespacho8',
  headers: ['accesstoken'],
  args: ['numerodespacho', 'fechadespacho', 'solicitudrecogida', 'unidadnegocio',
    'cuentaremitente', 'sederemitente', 'primernombreremitente',
    'segundonombreremitente', 'primerapellidoremitente', 'segundoapellidoremitente',
    'razonsocialremitente', 'contactoremitente', 'tipoidentificacionremitente',
    'identificacionremitente', 'direccionremitente', 'ciudadorigen', 'telefonoremitente',
    'emailremitente', 'destinatarios']
}

routes.anularRotulosDespachosMasivosTest = {
  route: '/rotulosdespacho/anularmasivostest',
  wsdl: 'http://clientes.tcc.com.co/preservicios/wsdespachos.asmx?wsdl',
  method: 'AnularDespachosPorCliente',
  args: ['clave', 'identificacion', 'remesas']
}

routes.anularRotulosDespachosMasivos = {
  route: '/rotulosdespacho/anularmasivos',
  wsdl: 'http://clientes.tcc.com.co/servicios/wsdespachos.asmx?wsdl',
  method: 'AnularDespachosPorCliente',
  args: ['clave', 'identificacion', 'remesas']
}

/* SOLICITAR RECOGIDA FECHAS */
routes.obtenerFechasSolicitudRecogidaTest = {
  route: '/solicitarrecogida/fechastest',
  wsdl: 'http://pre.servicios.aplicaciones.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarDiasEntrega',
  args: ['ciudadorigen', 'tiposervicio', 'unidadnegocio']
}

routes.obtenerFechasSolicitudRecogida = {
  route: '/solicitarrecogida/fechas',
  wsdl: 'http://prod.servicios.tcc.com.co:8011/Maestros/consultarMaestros?wsdl',
  method: 'consultarDiasEntrega',
  args: ['ciudadorigen', 'tiposervicio', 'unidadnegocio']
}

routes.obtenerCuentaFalkonTest = {
  route: '/clients/accounttest',
  type: 'rest',
  method: 'GET',
  endpoint: 'https://dev-falkon-descuentos.smk.agency/clients/account',
  headers: ['api-key'],
  args: ['id-type', 'id-number', 'business-unit'],
  api_key: process.env.VUE_APP_CLIENTS_ACCOUNT
}
routes.obtenerCuentaFalkon = {
  route: '/clients/account',
  type: 'rest',
  method: 'GET',
  endpoint: 'https://admin.falkon.com.co/api/clients/account',
  headers: ['api-key'],
  args: ['id-type', 'id-number', 'business-unit'],
  api_key: process.env.VUE_APP_CLIENTS_ACCOUNT
}

/* FALKON CONSULTO ESTIMACIÓN DE ENVÍOS */
routes.consultoEstimacionEnviosTest = {
  route: '/estimacionenviostest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/remesas/consultarinformacionremesafalkon',
  args: ['identificacion', 'fechainicial', 'fechafinal', 'remesas', 'destino', 'formapago']
}

routes.consultoEstimacionEnvios = {
  route: '/estimacionenvios',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/remesas/consultarinformacionremesafalkon',
  args: ['identificacion', 'fechainicial', 'fechafinal', 'remesas', 'destino', 'formapago']
}

/* FALKON TRANSACCIONAL RECAUDOS */
routes.recaudosInscripcionTest = {
  route: '/recaudosinscripciontest',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/integracion/crearclienteFalkon',
  args: ['IdTipoIdentificacion', 'Identificacion', 'TipoPersona', 'PrimerNombre',
    'SegundoNombre', 'PrimerApellido', 'SegundoApellido', 'RazonSocial',
    'DescripcionBanco', 'TipoCuenta', 'NumeroCuenta', 'CodigoBanco',
    'CorreoElectronico', 'Celular', 'documentoCCBase64', 'documentoCACOBase64',
    'documentoRUTBase64', 'documentoCEBANBase64'],
}
routes.recaudosInscripcion = {
  route: '/recaudosinscripcion',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://somos.tcc.com.co/api/clientes/integracion/crearclienteFalkon',
  args: ['IdTipoIdentificacion', 'Identificacion', 'TipoPersona', 'PrimerNombre',
    'SegundoNombre', 'PrimerApellido', 'SegundoApellido', 'RazonSocial',
    'DescripcionBanco', 'TipoCuenta', 'NumeroCuenta', 'CodigoBanco',
    'CorreoElectronico', 'Celular', 'documentoCCBase64', 'documentoCACOBase64',
    'documentoRUTBase64', 'documentoCEBANBase64'],
}

routes.recaudosListaBancosTest = {
  route: '/recaudoslistabancostest',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/integracion/consultarBancos',
  args: [],
}
routes.recaudosListaBancos = {
  route: '/recaudoslistabancos',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://somos.tcc.com.co/api/clientes/integracion/consultarBancos',
  args: [],
}

routes.recaudosConsultaMisPagosTest = {
  route: '/recaudosconsultamispagostest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/remesas/consultarremesasrecaudoV2',
  args: ['identificacion', 'fechainicial', 'fechafinal', 'estadopago', 'numeroremesa', 'estadorecaudo', 'fechapago', 'usuario'],
}
routes.recaudosConsultaMisPagos = {
  route: '/recaudosconsultamispagos',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/remesas/consultarremesasrecaudoV2',
  args: ['identificacion', 'fechainicial', 'fechafinal', 'estadopago', 'numeroremesa', 'estadorecaudo', 'fechapago', 'usuario'],
}

routes.recaudosConsultarClienteTest = {
  route: '/recaudosconsultarclientetest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/integracion/consultarClienteFalkon',
  args: ['IdTipoIdentificacion', 'Identificacion'],
}
routes.recaudosConsultarCliente = {
  route: '/recaudosconsultarcliente',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/integracion/consultarClienteFalkon',
  args: ['IdTipoIdentificacion', 'Identificacion'],
}


routes.consultarDocumentosNoLeidoTest = {
  route: '/consultardocumentosnoleidotest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/integracion/consultarDocumentosNoLeido',
  args: ['IdTipoIdentificacion', 'Identificacion'],
}
routes.consultarDocumentosNoLeido = {
  route: '/consultardocumentosnoleido',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/integracion/consultarDocumentosNoLeido',
  args: ['IdTipoIdentificacion', 'Identificacion'],
}

routes.actualizarClienteFalkonDocumentosTest = {
  route: '/actualizarclientefalkondocumentostest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/integracion/actualizarClienteFalkonDocumentos',
  args: [
    'DocId', 'TipoDocumentoId', 'EstadoDocumentoId', 'EstadoRegistroDetalle', 'IdTipoIdentificacion',
    'Identificacion', 'TipoPersona', 'PrimerNombre', 'SegundoNombre', 'PrimerApellido',
    'SegundoApellido', 'RazonSocial', 'CodigoBanco', 'DescripcionBanco', 'NumeroCuenta',
    'SucrusalBanco', 'CapitalSocial', 'MatriculaMercantil', 'DigitoVerificacion', 'Pais',
    'Estado', 'Ciudad', 'Direccion', 'ClaseActividadEconomica'
  ],
}
routes.actualizarClienteFalkonDocumentos = {
  route: '/actualizarclientefalkondocumentos',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/integracion/actualizarClienteFalkonDocumentos',
  args: [
    'DocId', 'TipoDocumentoId', 'EstadoDocumentoId', 'EstadoRegistroDetalle', 'IdTipoIdentificacion',
    'Identificacion', 'TipoPersona', 'PrimerNombre', 'SegundoNombre', 'PrimerApellido',
    'SegundoApellido', 'RazonSocial', 'CodigoBanco', 'DescripcionBanco', 'NumeroCuenta',
    'SucrusalBanco', 'CapitalSocial', 'MatriculaMercantil', 'DigitoVerificacion', 'Pais',
    'Estado', 'Ciudad', 'Direccion', 'ClaseActividadEconomica'
  ],
}

routes.consultarEstadosTest = {
  route: '/consultarestadostest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/integracion/consultarEstados',
  args: [],
}
routes.consultarEstados = {
  route: '/consultarestados',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/integracion/consultarEstados',
  args: [],
}

routes.consultarCiudadesTest = {
  route: '/consultarciudadestest',
  type: 'rest',
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/integracion/consultarCiudades',
  args: [],
}
routes.consultarCiudades = {
  route: '/consultarciudades',
  type: 'rest',
  endpoint: 'https://somos.tcc.com.co/api/clientes/integracion/consultarCiudades',
  args: [],
}

routes.consultarRecaudosProductosTest = {
  route: '/channel/api/recaudos-productos',
  type: 'rest',
  endpoint: 'https://tcc.smk.agency:8080/channel/api/recaudos-productos',
  args: ['IdTipoIdentificacion', 'Identificacion'],
}
routes.consultarRecaudosProductos = {
  route: '/channel/api/recaudos-productos',
  type: 'rest',
  endpoint: 'https://tccrestify-dot-tcc-cloud.appspot.com/channel/api/recaudos-productos',
  args: ['IdTipoIdentificacion', 'Identificacion'],
}

routes.novedadesSolucionFechasDisponiblesTest = {
  route: '/novedades/fechassoluciontest',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/planeacion/fechapromesaporremesa',
  args: ['numeroremesa', 'diasdisponibles'],
}

routes.novedadesSolucionFechasDisponibles = {
  route: '/novedades/fechassolucion',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://somos.tcc.com.co/api/clientes/planeacion/fechapromesaporremesa',
  args: ['numeroremesa', 'diasdisponibles'],
}

//consultar cuentas fletes
routes.consultarCuentasFleteTest = {
  route: '/channel/api/cuentas-flete-test',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://testsomos.tcc.com.co/api/clientes/integracion/consultarCuentas',
  args: ['TipoDocumento', 'NumeroDocumento', 'UnidadNegocio'],
}
routes.consultarCuentasFlete = {
  route: '/channel/api/cuentas-flete',
  type: 'rest',
  headers: ['accesstoken'],
  endpoint: 'https://somos.tcc.com.co/api/clientes/integracion/consultarCuentas',
  args: ['TipoDocumento', 'NumeroDocumento', 'UnidadNegocio'],
}

export default routes
